import FlatList from 'flatlist-react';
import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'underscore';
import {
  hideLoader,
  showErrorToast,
  showToast,
  updateShareContestStatus
} from '../../../actions/app-actions-types';
import {
  ErrorMessage,
  FlatListWrapper,
  HeaderWithTimer,
  PlaceHolder,
  ScreenBackground,
  View,
  Text,
  AddCashModal
} from '../../../component';
import EventEmitter from '../../../utilities/EventEmitter';
import {
  getRealBalanceObj,
  getRouteObjByGame,
  isMatchInScheduled
} from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import { ContestConfirmModal, NoContestJoined, TeamBox } from '../../component';
import { useRouteLocation, useLink } from 'react-router-stack';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { BsCheckSquareFill, BsSquare } from 'react-icons/bs';
import Button from '@mui/material/Button/Button';

const MyTeamsList = () => {
  const { FantasyTheme: theme } = useTheme();
  const navigate = useLink();
  const {
    userId,
    balanceInfo = {},
    item: matchItem = {},
    shareContestStatus,
    getMyMatchTeamList,
    fantasyMatchClick,
    getPlayerList,
    joinWithMultipleTeam,
    switchContestTeam,
    gameType
  } = useGame();
  const { state } = useRouteLocation() as any;
  let isFromCreateTeam = false;
  if (state) {
    isFromCreateTeam = state.isFromCreateTeam;
  }

  const balance = getRealBalanceObj(balanceInfo);
  const { isLanded = false } = shareContestStatus;
  const {
    _id: matchId,
    joinedMatch,
    contestId,
    entryFee,
    bonusPercentage = 0,
    isTeamSwitch = false,
    competition = {},
    leaderBoardTeamId = '',
    contestTeams = [],
    preSwitchTeamId = '',
    gameState = 0,
    status: matchStatus,
    maxTeamPerUser = 1,
    screenName = '',
    matchDelayed = false,

    // isEditSubstitute = false,
    tabType = 'FIXTURE'
  } = matchItem;

  const isScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });

  const { title = '' } = competition;
  const [addCashVisible, setAddCashVisible] = useState(false);
  const [myTeamList, setMyTeamList] = useState([] as any);
  const dispatch = useDispatch();
  const [resultArrivedTeamList, setResultArrivedTeamList] = useState(false);
  const [resultArrivedPlayerList, setResultArrivedPlayerList] = useState(false);
  const [contestConfirmModal, setContestConfirmModal] = useState(false);
  const [selectedTeamIdList, setSelectedTeamIdList] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [matchAllPlayersList, setMatchAllPlayerList] = useState([]);
  const [error, setError] = useState(false);
  const [lineupsOut, setLineupsOut] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const initSelectAllRef = useRef(() => {});
  const totalTeamsCount = myTeamList.length;

  useEffect(() => {
    getMyTeamList({});
    getAllPlayerListAPI();
    window.addEventListener('popstate', onClickBrowserBack);
    EventEmitter.on('teamUpdate', getMyTeamList);
    return () => {
      EventEmitter.off('teamUpdate', getMyTeamList);
      window.removeEventListener('popstate', onClickBrowserBack);
    };
  }, []);

  const onClickBrowserBack = () => {
    setContestConfirmModal(false);
    setAddCashVisible(false);
  };

  const getAllPlayerListAPI = () => {
    const data = {
      matchId
    };
    dispatch(
      getPlayerList({
        data,
        callback: ({ result = [], error }: { result: any; error: any }) => {
          if (!error && result) {
            setResultArrivedPlayerList(true);
            setMatchAllPlayerList(result);
            ///this is for calculate line up out
            let playingPlayersList = [];
            playingPlayersList = result.filter(
              (player: { playingEleven: boolean }) => player.playingEleven === true
            );
            setLineupsOut(playingPlayersList.length >= 15);
          } else {
            setError(true);
          }
        }
      })
    );
  };

  const getMyTeamList = async ({ latestTeamData = { id: '' } } = {}) => {
    const data = {
      matchId,
      userId
    };
    await dispatch(
      getMyMatchTeamList({
        data,
        callback: ({ result = [], error }: { result: any; error: any }) => {
          if (!error && result) {
            const { id = '' } = latestTeamData;
            let isNotExistLatestTeam = _.findWhere(result, { id });
            if (id && !isNotExistLatestTeam) {
              result.push(latestTeamData);
            }
            result.sort((a: { teamNumber: number }, b: { teamNumber: number }) =>
              a.teamNumber > b.teamNumber ? 1 : -1
            );
            result = result.map((item: any) => {
              return { ...item, isSelected: false };
            });
            setMyTeamList(result);
            setResultArrivedTeamList(true);
            setError(false);
            initSelectAllRef.current();
          } else {
            setError(true);
          }
        }
      })
    );
  };

  const onPressSwitchTeam = () => {
    const [teamObj = {}]: any = selectedTeamIdList;
    const { _id: selectTeamId = '' } = teamObj;
    if (isScheduled) {
      if (selectTeamId !== preSwitchTeamId) {
        dispatch(
          switchContestTeam({
            data: {
              contestId,
              userTeamId: selectTeamId,
              contestTeamId: leaderBoardTeamId
            },
            callback: ({ error = '' }) => {
              dispatch(hideLoader());
              if (!error) {
                dispatch(
                  fantasyMatchClick({
                    data: {
                      ...matchItem,
                      completed: false,
                      joined: false,
                      joinedMatch: false,
                      contestId: '',
                      entryFee: '',
                      isTeamSwitch: false
                    }
                  })
                );
                dispatch(showToast(I18n.t('teamSwitchedSuccessfully')));
                EventEmitter.emit('updateLeaderBoard');
                navigate.go(isFromCreateTeam ? -3 : -1);
              } else dispatch(showErrorToast(I18n.t('SomethingWentWrong')));
            }
          })
        );
      } else {
        dispatch(showToast(I18n.t('teamSwitchedErrorMessage')));
      }
    } else {
      dispatch(showErrorToast(I18n.t('matchDeadlineFinishedSorryYouCannotJoinNow')));
    }
  };

  const onRefresh = async () => {
    await getMyTeamList({});
  };

  const onPressPreview = (teamData: any, teamNumber: any) => {
    navigate.push(getRouteObjByGame(gameType)['team_preview'], {
      teamData,
      matchId,
      teamNumber,
      item: matchItem,
      fromCreateTeam: false,
      lineupsOut,
      matchAllPlayersList,
      gameType,
      isMyUser: true
    });
  };

  const onPressConvertSubstituteMode = (teamData: any, teamNumber: any) => {
    navigate.push(getRouteObjByGame(gameType)['team_preview'], {
      teamData: teamData,
      matchId,
      teamNumber,
      item: matchItem,
      fromCreateTeam: false,
      lineupsOut,
      matchAllPlayersList,
      isMyUser: true
    });
  };

  const onPressClone = (teamData: any, teamNumber: any) => {
    const { players = [] } = teamData;
    let playerList: any[] = [];
    const substitutePlayerList = players.filter((x: any) => x.substitutePlayerId);
    players.forEach((item: any) => {
      let substituteObj = _.findWhere(substitutePlayerList, {
        substitutePlayerId: item.playerId
      });
      if (!substituteObj) {
        playerList.push({
          id: item.id,
          playerId: item.playerId,
          state: 0
        });
      }
    });

    if (totalTeamsCount < 11) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            selectedTeamPlayers: playerList,
            isEdit: false,
            teamNumber,
            isClone: true,
            joinedMatch,
            entryFee,
            contestId,
            teamData: {
              ...teamData,
              teamNumber: totalTeamsCount + 1
            },
            bonusPercentage,
            isTeamSwitch,
            isFromMyTeam: true
          }
        })
      );
      navigate.push(getRouteObjByGame(gameType)['create_team']);
    } else {
      dispatch(showToast(I18n.t('maxTeamMsg')));
    }
  };

  const onPressEdit = (teamData: any, teamNumber: any) => {
    const { players = [], substitutedCaptainId = '', substitutedViceCaptainId = '' } = teamData;
    let playerList: any[] = [];
    const substitutionPlayerList = players.filter((x: any) => x.substitutePlayerId);
    const substitutePlayerList: any[] = [];
    const substitutePlayers = {} as any;
    players.forEach((item: any) => {
      let substituteObj = _.findWhere(substitutionPlayerList, {
        substitutePlayerId: item.playerId
      });
      if (!substituteObj) {
        playerList.push({
          id: item.id,
          playerId: item.playerId,
          state: 0,
          substitutePlayerId: item.substitutePlayerId
        });
      } else {
        substitutePlayerList.push({
          id: item.id,
          playerId: item.playerId,
          state: 0
        });
        substitutePlayers[item.playerId] = 1;
      }
    });

    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          selectedTeamPlayers: playerList,
          isEdit: true,
          teamNumber,
          joinedMatch,
          isClone: false,
          entryFee,
          contestId,
          teamData,
          bonusPercentage,
          isTeamSwitch,
          substitutePlayerList,
          substitutePlayers,
          substitutedCaptainId,
          substitutedViceCaptainId
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['create_team']);
  };

  const joinContestWithMultipleTeams = () => {
    const teamList: { matchTeamId: any }[] = [];
    selectedTeamIdList.forEach((item: any) => {
      teamList.push({
        matchTeamId: item._id
      });
    });
    const data = {
      matchId,
      contestId,
      teamList
    };
    dispatch(
      joinWithMultipleTeam({
        data,
        callback: ({ error = {}, result = {} }: { result: any; error: any }) => {
          EventEmitter.emit('updateContestsList');
          if (!error) {
            redirectPageToContest(result);
          } else {
            const { message = '' } = error;
            if (message === 'insufficient funds') {
              onPressAddCash();
            } else if (message.includes('team per user is allowed for this contest')) {
              redirectPageToContestError();
            }
          }
        }
      })
    );
  };

  const redirectPageToContestError = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: false,
          contestId: '',
          entryFee: '',
          myContestJoinedTeams: [],
          contestType: {}
        }
      })
    );

    EventEmitter.emit('BalanceUpdate');
    EventEmitter.emit('updateMyContests');
    if (screenName === 'CONTEST_DETAILS') {
      EventEmitter.emit('updateContestDetails');
      EventEmitter.emit('updateLeaderBoard');
    }
    if (screenName === 'ALL_CONTEST') EventEmitter.emit('updateContestsList');
    if (isLanded) {
      dispatch(updateShareContestStatus({ ...shareContestStatus, isJoined: true }));
    }
    navigate.go(isFromCreateTeam ? -3 : -1);
  };

  const redirectPageToContest = (result: { error?: any; message?: any }) => {
    const { error = '', message = '' } = result;
    dispatch(showToast(error ? error : message ? message : I18n.t('ContestJoinedSuccessfully')));
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: false,
          contestId: '',
          entryFee: '',
          myContestJoinedTeams: [],
          contestType: {}
        }
      })
    );

    EventEmitter.emit('BalanceUpdate');
    EventEmitter.emit('updateMyContests');
    if (screenName === 'CONTEST_DETAILS') {
      EventEmitter.emit('updateContestDetails');
      EventEmitter.emit('updateLeaderBoard');
    }
    if (screenName === 'ALL_CONTEST') EventEmitter.emit('updateContestsList');
    if (isTeamSwitch) EventEmitter.emit('switchTeamMyMatch');

    if (isLanded) {
      dispatch(updateShareContestStatus({ ...shareContestStatus, isJoined: true }));
    }
    navigate.go(isFromCreateTeam ? -3 : -1);
  };

  // eslint-disable-next-line no-unused-vars
  const onPressJoinContest = (entryFee: any, usableBalance: any) => {
    if (isScheduled) {
      if (selectedTeamIdList.length > 0) {
        setContestConfirmModal(false);
        setTimeout(() => {
          joinContestWithMultipleTeams();
        }, 300);
      } else {
        alert('Please select the team to join contest');
      }
    } else {
      dispatch(showErrorToast(I18n.t('matchDeadlineFinishedSorryYouCannotJoinNow')));
    }
  };

  const selectTeamByUser = (selectedTeamIndex = 0) => {
    if (maxTeamPerUser === 1 || isTeamSwitch) {
      myTeamList.forEach((_item: any, index: number) => {
        if (index === selectedTeamIndex) {
          myTeamList[index].isSelected = !myTeamList[index].isSelected;
        } else {
          myTeamList[index].isSelected = false;
        }
      });
      setForceUpdate(!forceUpdate);
    } else {
      let previousMyTeamList = myTeamList.filter(function (el: { isSelected: any }) {
        return el.isSelected;
      });
      if (previousMyTeamList.length < maxTeamPerUser || myTeamList[selectedTeamIndex].isSelected) {
        myTeamList[selectedTeamIndex].isSelected = !myTeamList[selectedTeamIndex].isSelected;
        setForceUpdate(!forceUpdate);
      } else {
        dispatch(
          showErrorToast(
            `maximum teams selected (${maxTeamPerUser}). Please deselect, to select others`
          )
        );
      }
    }

    setSelectTeamList();
  };

  const onPressAlreadyJoin = () => {
    dispatch(showToast(I18n.t('alreadyJoinedWithThisTeam')));
  };

  const setSelectTeamList = () => {
    let selectedMyTeamList = myTeamList.filter(function (el: { isSelected: any }) {
      return el.isSelected;
    });
    setSelectAll(selectedMyTeamList.length === myTeamList.length - contestTeams.length);
    setSelectedTeamIdList(selectedMyTeamList);
  };

  const renderItem = (item: any) => {
    return (
      <TeamBox
        selectTeamByUser={selectTeamByUser}
        joinedMatch={true}
        item={item}
        key={item.matchTeamId}
        onPressPreview={onPressPreview}
        onPressClone={onPressClone}
        onPressEdit={onPressEdit}
        onPressAlreadyJoin={onPressAlreadyJoin}
        lineupsOut={lineupsOut}
        title={title}
        matchAllPlayersList={matchAllPlayersList}
        contestTeams={contestTeams}
        gameType={gameType}
        tabType={tabType}
        onPressConvertSubstituteMode={onPressConvertSubstituteMode}
      />
    );
  };

  const onPressRetry = () => {
    setResultArrivedTeamList(false);
    getMyTeamList({});
  };

  const onPressAddTeam = () => {
    if (totalTeamsCount < 11) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            isEdit: false,
            isClone: false,
            joinedMatch,
            entryFee,
            contestId,
            isTeamSwitch,
            selectedTeamPlayers: [],
            teamData: {
              teamNumber: totalTeamsCount + 1
            },
            isFromMyTeam: true
          }
        })
      );
      navigate.push(getRouteObjByGame(gameType)['create_team']);
    } else {
      dispatch(showToast(I18n.t('maxTeamMsg')));
    }
  };

  const renderWhenEmpty = () => {
    if (!resultArrivedTeamList || !resultArrivedPlayerList)
      return <PlaceHolder.Loader loadingMessage={''} />;
    if (error) return <ErrorMessage onPressRetry={onPressRetry} />;
    return (
      <NoContestJoined
        message={I18n.t('NoTeam')}
        buttonLabel={I18n.t('CreateYourTeam')}
        onPress={onPressAddTeam}
      />
    );
  };

  const onPressBack = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: false,
          contestId: '',
          entryFee: '',
          isTeamSwitch: false,
          myContestJoinedTeams: [],
          contestType: {}
        }
      })
    );
    if (isLanded) {
      dispatch(
        updateShareContestStatus({
          isJoined: false,
          isLanded: false
        })
      );
    }
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const initSelectAll = () => {
    if (selectAll) {
      let count = maxTeamPerUser - contestTeams.length;
      myTeamList.forEach((item: { _id: any }, index: string | number) => {
        if (count <= 0) return true;
        const isJoined = _.findWhere(contestTeams, { matchTeamId: item._id });
        if (isJoined) {
          myTeamList[index].isSelected = false;
        } else {
          count--;
          myTeamList[index].isSelected = true;
        }
      });
      setSelectTeamList();
    }
  };

  initSelectAllRef.current = initSelectAll;

  const onPressSelectAll = () => {
    let count = maxTeamPerUser - contestTeams.length;
    myTeamList.forEach((item: { _id: any }, index: string | number) => {
      if (count <= 0) return true;
      const isJoined = _.findWhere(contestTeams, { matchTeamId: item._id });
      if (isJoined) {
        myTeamList[index].isSelected = false;
      } else {
        count--;
        myTeamList[index].isSelected = !selectAll;
      }
    });
    setSelectAll(!selectAll);
    setSelectTeamList();
  };

  const createTeamBtnColor: any = {
    backgroundColor: theme.myTeamCreateTeamBtn,
    color: '#fff',
    fontFamily: 'ProximaNova-Bold',
    textTransform: 'none'
  };

  const switchTeamColor: any = {
    backgroundColor: theme.myTeamSwitchTeam,
    color: '#fff',
    fontFamily: 'ProximaNova-Bold',
    textTransform: 'none'
  };

  const disableBtn = {
    backgroundColor: theme.myTeamJoinContestDisableBtn
  };

  // const disableBtnText = {
  //   color: theme.myTeamJoinContestDisableBtnText
  // };

  const onPressJoinContestBtn = () => {
    setContestConfirmModal(true);
  };

  const onPressDismissCashModal = () => {
    setAddCashVisible(false);
  };

  const onPressAddCash = () => {
    setAddCashVisible(true);
  };
  const onCalledDeadline = () => {
    navigate.replace('/', { replace: true });
  };
  return (
    <ScreenBackground isRouterWrap={true}>
      <HeaderWithTimer
        onPressBack={onPressBack}
        matchItem={matchItem}
        onCalledDeadline={onCalledDeadline}
        gameType={gameType}
      />
      <View className="my-team-list-container">
        {!isTeamSwitch && maxTeamPerUser > 1 && (
          <View className={'my-team-list-select-all-container'} onPress={onPressSelectAll}>
            {selectAll ? (
              <BsCheckSquareFill size={'20px'} fill={theme.myTeamSelectAllBtn} />
            ) : (
              <BsSquare size={'20px'} fill={theme.myTeamSelectAllBtn} />
            )}
            <Text
              className={'my-team-list-select-all'}
              style={{
                color: theme.myTeamSelectAllBtn
              }}>
              {'Select All'}
            </Text>
          </View>
        )}
        <PullToRefresh onRefresh={onRefresh}>
          <FlatListWrapper
            style={{
              paddingBottom: '40px'
            }}>
            <FlatList
              list={myTeamList}
              renderItem={renderItem}
              renderWhenEmpty={renderWhenEmpty}
              renderOnScroll
            />
          </FlatListWrapper>
        </PullToRefresh>

        <View className={'my-team-list-bottom-card'}>
          {totalTeamsCount < 11 && (
            <Button
              className={'my-team-list-create-button'}
              onClick={onPressAddTeam}
              style={createTeamBtnColor}>
              {I18n.t('createTeam')}
            </Button>
          )}
          <Button
            className={'my-team-list-create-button'}
            onClick={isTeamSwitch ? onPressSwitchTeam : onPressJoinContestBtn}
            style={selectedTeamIdList.length > 0 ? switchTeamColor : disableBtn}
            disabled={selectedTeamIdList.length === 0 ? true : false}>
            {isTeamSwitch ? I18n.t('switchTeam') : I18n.t('joinContest')}
          </Button>
        </View>

        <ContestConfirmModal
          visible={contestConfirmModal}
          onPressDismiss={() => setContestConfirmModal(false)}
          entryFee={entryFee / 100}
          selectedTeamCount={selectedTeamIdList.length}
          joinContest={onPressJoinContest}
          bonusPercentage={bonusPercentage}
        />
        <AddCashModal
          totalAmount={balance['totalBalance']}
          visible={addCashVisible}
          onPressDismiss={onPressDismissCashModal}
        />
      </View>
    </ScreenBackground>
  );
};

export default MyTeamsList;
